import { GLYPH_PATHS, GLYPH_VIEWBOX, type GlyphName } from './glyph-paths.js';

/**
 * One Material Symbol, drawn from `glyph-paths.ts`.
 *
 * The design gives each glyph a `font-size` and lets line-height place it; the
 * SVG equivalent is an explicit square that sits on the text baseline, which is
 * what `verticalAlign` does here.
 *
 * `aria-hidden` on every one of them. None of the six is the only carrier of
 * anything: the search box has a placeholder, the weather glyph sits beside its
 * state in words, and the error mark sits beside its sentence. A decorative
 * image announced to a screen reader is noise.
 */
export function Glyph(props: {
  readonly name: GlyphName;
  readonly size?: number;
  readonly title?: string;
}): JSX.Element {
  const size = props.size ?? 16;
  return (
    <svg
      data-glyph={props.name}
      viewBox={GLYPH_VIEWBOX}
      width={size}
      height={size}
      focusable="false"
      aria-hidden="true"
      style={{ flex: 'none', display: 'block', fill: 'currentColor', verticalAlign: 'middle' }}
    >
      {props.title !== undefined && <title>{props.title}</title>}
      <path d={GLYPH_PATHS[props.name]} />
    </svg>
  );
}
